/**
 * Total unread incoming messages in loaded conversations + internal chat rooms.
 */
export const getTotalUnreadCount = store => {
  if (!store?.getters) return 0;

  const conversationUnread = Number(
    store.getters.getTotalUnreadMessagesCount || 0
  );
  const internalUnread = Number(
    store.getters['internalChat/totalUnreadCount'] || 0
  );

  return conversationUnread + internalUnread;
};
